__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "user-ecosystem";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@auth/auth", "0.9.1", () => (__webpack_require__.e("node_modules_auth_auth_fesm2022_auth-auth_mjs-_48770").then(() => (() => (__webpack_require__(/*! ./node_modules/@auth/auth/fesm2022/auth-auth.mjs */ 5975))))));
			register("@auth0/auth0-angular", "2.2.3", () => (__webpack_require__.e("node_modules_auth0_auth0-angular_fesm2020_auth0-auth0-angular_mjs-_08060").then(() => (() => (__webpack_require__(/*! ./node_modules/@auth0/auth0-angular/fesm2020/auth0-auth0-angular.mjs */ 5923))))));
			register("@auth0/auth0-spa-js", "2.1.3", () => (__webpack_require__.e("node_modules_auth0_auth0-spa-js_dist_auth0-spa-js_production_esm_js-_76071").then(() => (() => (__webpack_require__(/*! ./node_modules/@auth0/auth0-spa-js/dist/auth0-spa-js.production.esm.js */ 6377))))));
			register("@usereco/usereco-lib", "0.1.0", () => (__webpack_require__.e("node_modules_usereco_usereco-lib_fesm2022_usereco-usereco-lib_mjs-_88021").then(() => (() => (__webpack_require__(/*! ./node_modules/@usereco/usereco-lib/fesm2022/usereco-usereco-lib.mjs */ 4671))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};